import React, { Component } from 'react'
import PropTypes from 'prop-types'
import request from './../utils/requestConfig'
// components
import ForgetPassword from './../components/ForgetPassword'

class ForgetPasswordContainer extends Component {
  constructor () {
    super()
    this.state = {
      isProcessing: false,
      message: ''
    }
    this.requestRecover = this.requestRecover.bind(this)
  }

  requestRecover (credentials) {
    this.setState({ isProcessing: true, message: '' })
    request.post('/users/recover_password', {
      login: credentials.email
    }).then((data) => {
      this.setState({
        isProcessing: false,
        message: 'O email de recuperação foi enviado para a sua caixa de entrada.'
      })
    })
  }

  render () {
    const { className } = this.props
    const { isProcessing, message } = this.state
    return (
      <ForgetPassword
        isProcessing={isProcessing}
        message={message}
        requestRecover={this.requestRecover}
        className={className}
      />
    )
  }
}

ForgetPasswordContainer.propTypes = {
  className: PropTypes.string
}

export default ForgetPasswordContainer



// WEBPACK FOOTER //
// ./src/containers/ForgetPasswordContainer.js